import React, { useState, useEffect } from 'react';
import BasicSelect from '../../../components/shared/fields/BasicSelect';

const StatusFilter = ({ onChange, clearFilter }) => {
  const statusOptions = [
    { value: 'paid', label: 'Paga' },
    { value: 'partially_paid', label: 'Paga parcialmente' },
    { value: 'pending', label: 'Aguardando pagamento' },
    { value: 'overdue', label: 'Vencida' },
    { value: 'canceled', label: 'Cancelada' },
  ];

  const [status, setStatus] = useState(statusOptions.map((opt) => opt.value));

  const handleStatusChange = (event) => {
    const {
      target: { value },
    } = event;
    const updatedValue = typeof value === 'string' ? value.split(',') : value;
    onChange(updatedValue);
    setStatus(updatedValue);
  };

  useEffect(() => {
    if (clearFilter) {
      setStatus(statusOptions.map((opt) => opt.value));
    }
  }, [clearFilter]);

  return (
    <BasicSelect
      label="Status"
      value={status}
      onChange={handleStatusChange}
      options={statusOptions}
      multiple
      useChips
      limitTags={2}
      renderValue={(selected) => {
        if (selected.length === statusOptions.length) return 'Todos';
        const selectedLabels = statusOptions.filter((opt) => selected.includes(opt.value)).map((opt) => opt.label);
        return (
          <div style={{ display: 'flex', flexWrap: 'wrap', gap: 4 }}>
            {selectedLabels.map((label) => (
              <span
                key={label}
                style={{
                  background: '#e0e0e0',
                  borderRadius: '16px',
                  padding: '0.4rem 0.85rem',
                  fontSize: '0.875rem',
                }}
              >
                {label}
              </span>
            ))}
          </div>
        );
      }}
    />
  );
};

export default StatusFilter;
